import { FC } from "react";
import MobilePopup from "@/components/MobilePopup";
import Typography from "@/components/Typography";
import Button from "@/components/Button";
import styles from "./MobileConversationDeleteConfirmationDialog.module.scss";

type Props = {
  onClose: () => void;
  onDelete: () => void;
  isDeleting: boolean;
};

const MobileConversationDeleteConfirmationDialog: FC<Props> = ({
  onClose,
  onDelete,
  isDeleting,
}) => {
  return (
    <MobilePopup onClose={onClose}>
      <div className={styles.root}>
        <Typography variant="h6">Delete confirmation</Typography>
        <Typography variant="body1" className={styles.text}>
          Do you want to delete this chat?
        </Typography>
        <Button
          onClick={onDelete}
          color="error"
          className={styles.button}
          disabled={isDeleting}
        >
          {isDeleting ? "Deleting..." : "Delete"}
        </Button>
      </div>
    </MobilePopup>
  );
};

export default MobileConversationDeleteConfirmationDialog;
